import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  private httpWithoutInterceptors: HttpClient;

  constructor(
    private http: HttpClient,
    private handler: HttpBackend
  ) {
    this.httpWithoutInterceptors = new HttpClient(handler);
  }

  downloadFile(
    url: string,
    filename: string,
    skipInterceptors = false
  ): Observable<void> {
    const client = skipInterceptors ? this.httpWithoutInterceptors : this.http;
    return client.get(url, { responseType: 'blob' }).pipe(
      map(blob => {
        try {
          saveAs(blob, filename);
        } catch (e) {
          console.error(e);
        }
      })
    );
  }
}
